<div class="app-searchable-dropdown" [ngClass]="customClass" [class.app-searchable-dropdown--full-width]="fullWidth">
  <!-- Optional Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
  ></app-label>

  <!-- Trigger Area -->
  <div class="app-searchable-dropdown__trigger-wrapper" (click)="toggleDropdown($event)">
    <ng-content select="[appTrigger], [trigger], [dropdownTrigger], [selectTrigger]"></ng-content>
  </div>

  <!-- Dropdown Menu Panel -->
  <div
    *ngIf="isOpen"
    class="app-searchable-dropdown__panel"
    [style.minWidth]="minWidth"
    [style.maxWidth]="maxWidth"
    (click)="$event.stopPropagation()"
  >
    <!-- Search Bar -->
    <div *ngIf="searchable" class="app-searchable-dropdown__search">
      <div class="app-searchable-dropdown__search-wrap">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="#9AA9BE" class="app-searchable-dropdown__search-icon">
          <path
            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
          />
        </svg>
        <input
          #searchInput
          type="text"
          class="app-searchable-dropdown__search-input"
          [placeholder]="searchPlaceholder"
          [value]="searchTerm"
          (input)="onSearchInput($event)"
          (click)="$event.stopPropagation()"
        />
        <span
          *ngIf="searchTerm"
          class="app-searchable-dropdown__search-clear"
          (click)="handleClearSearch($event)"
        >
          <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm2.47-9.53a.75.75 0 0 0-1.06-1.06L8 5.82 6.59 4.41a.75.75 0 0 0-1.06 1.06L6.94 6.88 5.53 8.29a.75.75 0 1 0 1.06 1.06L8 7.94l1.41 1.41a.75.75 0 0 0 1.06-1.06L9.06 6.88l1.41-1.41z"/>
          </svg>
        </span>
      </div>
    </div>

    <!-- Options List -->
    <div class="app-searchable-dropdown__options" [style.maxHeight]="maxHeight">
      <ng-container *ngFor="let opt of filteredOptions; trackBy: trackByOption">
        <div
          class="app-searchable-dropdown__option"
          [ngClass]="{
            'app-searchable-dropdown__option--selected': opt.value === value || (selectedOption && selectedOption.value === opt.value),
            'app-searchable-dropdown__option--disabled': opt.disabled
          }"
          (click)="selectOption(opt, $event)"
        >
          <ng-container *ngIf="!itemTemplate; else customItemTpl">
            <img *ngIf="opt.icon" [src]="opt.icon" class="app-searchable-dropdown__option-icon" alt="" />
            <div class="app-searchable-dropdown__option-content">
              <span class="app-searchable-dropdown__option-label">{{ opt.label }}</span>
              <span *ngIf="opt.sublabel" class="app-searchable-dropdown__option-sublabel">{{ opt.sublabel }}</span>
            </div>
          </ng-container>
          <ng-template #customItemTpl>
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: opt.data || opt, option: opt }"></ng-container>
          </ng-template>
        </div>
      </ng-container>

      <!-- Empty State -->
      <div *ngIf="filteredOptions.length === 0" class="app-searchable-dropdown__no-options">
        {{ emptyText }}
      </div>
    </div>

    <!-- Footer Action -->
    <div *ngIf="footerBtnName" class="app-searchable-dropdown__footer">
      <app-add-action-button
        class="w-100"
        [fullWidth]="true"
        [btnName]="footerBtnName"
        [isSvgShow]="footerBtnIcon"
        (btnClick)="onFooterClick($event)"
      ></app-add-action-button>
    </div>
    <div class="app-searchable-dropdown__custom-footer">
      <ng-content select="[appFooter], [footer]"></ng-content>
    </div>
  </div>
</div>
